import { Box, Text } from '@chakra-ui/react';
import React from 'react';

const PreviewAcademic = ({ items }) => {

  return (
    <Box className="contentBox">
      {Object.values(items).map((item) => {
          const subject = typeof item.subject === 'undefined' ? '' : item.subject[0];
          return (
            <Text className="subSections">
              <Box className="date">
                <Text className="name">{item.organization}</Text>
              </Box>
              <Box>
                <Text>{subject}</Text>
                <Text>{item.issues}</Text>
              </Box>
            </Text>
          );
        },
      )}
    </Box>
  );
};
export default PreviewAcademic;
